import React, { useState, useEffect } from "react";
import JobPostCard from "./JobPostCard";
import JobDescription from "./JobDescription";

const JobListPanel = ({ jobs, onSelect }) => {

    const [selected, setSelected] = useState(null);
    const [rightPanelOpen, setRightPanelOpen] = useState(false);

    const handleSelect = (job) => {
        setSelected(job);
        setRightPanelOpen(true);
    };

    return (
        <div className="flex gap-4">
            <div className={`${rightPanelOpen ? 'w-1/3' : 'w-full'}`}>
            {jobs?.map((job) => (
                <div className="relative group gradient-effect space-y-4">
                <div className="hover-effect group-hover:opacity-30 transition-opacity duration-300" />
                    <JobPostCard
                        key={job.jpo_id}                     
                        recordData={job}
                        handleSelect={handleSelect}
                    />
                </div>

            ))}
            </div>
            <div className={`flex ${rightPanelOpen ? 'visible w-full' : 'hidden'}`}>
                <JobDescription recordData={selected} />
            </div>
        </div>
    );
};

export default JobListPanel;